import { useState } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { getConfig } from "services/config.service";
import { useTheme } from "@mui/material/styles";
import { useSiteInformation } from "./hooks/useSiteInformationQueries";
import { DialogComponent } from "../dialogs/dialog.component";
import { Grid, IconButton } from "@mui/material";
import CopyIcon from "@mui/icons-material/ContentCopyOutlined";
import { SwaggerLink } from "./footer.style";
import { useTranslation } from "react-i18next";

export const FooterComponent = () => {
  const { t } = useTranslation();
  const [showVersionInfo, setShowVersionInfo] = useState(false);
  const { data: siteInfo } = useSiteInformation();
  const theme = useTheme();

  const softwareVersion = siteInfo?.version ?? "";
  const environmentName = siteInfo?.environment ?? "";

  const copyVersionsToClipboard = () => {
    navigator.clipboard.writeText(
      `${t("Footer_Label_FrontendVersion")} ${import.meta.env.VITE_VERSION}
        ${t("Footer_Label_BackendVersion")} ${softwareVersion}
        ${t("Footer_Label_Environment")} ${environmentName}`,
    );
  };

  const renderDialog = () => {
    return (
      <DialogComponent
        title={t("Footer_Dialog_Title_VersionInfo")}
        isOpen={showVersionInfo}
        options={[
          {
            title: t("Footer_Dialog_Button_Close"),
            handleOption: () => {
              setShowVersionInfo(false);
            },
          },
        ]}
        onClose={() => {
          setShowVersionInfo(false);
        }}
      >
        <Grid container width={"300px"}>
          <Grid size={7}>
            <Stack spacing={2}>
              <div>{t("Footer_Label_FrontendVersion")}</div>
              <div>{t("Footer_Label_BackendVersion")}</div>
              <div>{t("Footer_Label_Environment")}</div>
            </Stack>
          </Grid>
          <Grid size={3} sx={{ color: theme.custom.colors.mediDarkerGray }}>
            <Stack spacing={2}>
              <div>{import.meta.env.VITE_VERSION}</div>
              <div>
                {softwareVersion.includes("+") ? "0.0.0" : softwareVersion}
              </div>
              <div>{environmentName}</div>
            </Stack>
          </Grid>
          <Grid size={2}>
            <IconButton
              sx={{ outline: "none", ml: 2 }}
              onClick={copyVersionsToClipboard}
            >
              <CopyIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogComponent>
    );
  };

  return (
    <Box sx={{ bgcolor: theme.custom.colors.mediLightGray, flexShrink: 0 }}>
      <Container>
        <Stack direction="row" alignItems="center">
          {renderDialog()}
          <Box sx={{ alignSelf: "center" }}>
            <Typography
              sx={{
                color: theme.custom.colors.mediMagenta,
                fontWeight: "bold",
                my: 1.25,
              }}
            >
              medi. ich fühl mich besser.
            </Typography>
          </Box>
          <Box sx={{ ml: "auto" }}>
            <SwaggerLink onClick={() => setShowVersionInfo(true)}>
              {t("Footer_Link_VersionInfo")}
            </SwaggerLink>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};
